import React, { useState, useEffect, PropsWithChildren } from "react";
import cn from "classnames";

import styles from "./TrackingTooltip.module.scss";

interface TooltipProps {
    className?: string;
}

const Tooltip: React.FC<TooltipProps> = function ({ className, children }: PropsWithChildren<TooltipProps>) {
    const [position, setPosition] = useState<{ x: number; y: number }>();

    const handleMouseMove = (event: React.MouseEvent): void => {
        setPosition({ x: event.clientX, y: event.clientY });
    };

    useEffect(() => {
        window.addEventListener("mousemove", (handleMouseMove as unknown) as EventListener);

        return (): void => {
            window.removeEventListener("mousemove", (handleMouseMove as unknown) as EventListener);
        };
    }, []);

    if (position) {
        return (
            <div className={cn(styles.tooltip, className)} style={{ left: position.x, top: position.y }}>
                <div className={styles.content}>{children}</div>
            </div>
        );
    } else {
        return null;
    }
};

export default Tooltip;
